module.exports = __webpack_public_path__ + "static/media/arrow-back.bda31bfa.svg";